module.exports = __webpack_public_path__ + "img/wxBtn.f661c730.png";